import type { ScheduledEvent } from '@/types'

const now = Date.now()
const hr = 3_600_000
const day = 86_400_000

export const scheduledEvents: Record<string, ScheduledEvent[]> = {
  's1': [
    { id: 'ev1', serverId: 's1', channelId: 'ch6', title: 'Community Voice Hangout', description: 'Weekly open mic. Come say hi!', startAt: now + 2 * day, endAt: now + 2 * day + 2 * hr, rsvpUserIds: ['u1', 'u2', 'u3', 'u7'] },
    { id: 'ev2', serverId: 's1', channelId: 'ch5', title: 'Dev Q&A Session', description: 'Ask the dev team anything about Arcus internals.', startAt: now + 4 * day, endAt: now + 4 * day + 1 * hr, rsvpUserIds: ['u1', 'u4', 'u8'] },
    { id: 'ev3', serverId: 's1', title: 'Beta Launch Party', description: 'Celebrating the public beta launch. Spatial audio showcase and demos.', startAt: now + 7 * day, rsvpUserIds: ['u1', 'u2', 'u3', 'u4', 'u7', 'u8'] },
  ],
  's4': [
    { id: 'ev4', serverId: 's4', channelId: 'ch16', title: 'Friday Game Night', description: 'This week: Phasmophobia with spatial audio!', startAt: now + 3 * day, endAt: now + 3 * day + 3 * hr, rsvpUserIds: ['u2', 'u3', 'u7'] },
    { id: 'ev5', serverId: 's4', channelId: 'ch16', title: 'Mario Kart Tournament', description: 'Single elimination bracket. Winner gets a custom role.', startAt: now + 10 * day, rsvpUserIds: ['u3', 'u4'] },
  ],
}
